<template>
    <div v-if="withButton">
        <b-form-group v-bind="$attrs">
            <b-button variant="primary" @click="editor.show = true"> {{ btnLabel }} </b-button>
        </b-form-group>

        <template v-if="sidebar">
            <b-sidebar right v-model="editor.show">
                <ul class="editor-controls" v-if="controls">
                    <li v-if="canDisplayControl('libs')"><Libs :libs="libs"/></li>
                    <li><Snippets @snippetUsed="implementSnippet" :code="snippetSelected" /></li>
                    <li><Controls :keys="extraKeys" /></li>
                </ul>
                <b-form-group 
                    :description="editor_description"
                >
                <div class="libs-editor-wrapper" :style="{height: `calc(${this.getLibsEditorLineCount()} * 21.4px)`, 'max-height': `calc(14*21.4px)`, 'overflow': 'hidden'}">
                <codemirror 
                    ref="editorLibs" 
                    :value="imports"
                    :options="libsEditorOptions"
                    :readOnly="true"
                    @ready="editorLibsReady"
                    :style="{visibility: (libs.length < 1 && vars.length < 1) ? 'hidden' : 'visible'}"
                    >
                    </codemirror>
                </div>
                <codemirror 
                    v-if="loadEditor"
                    ref="editor"
                    @input="onChange"
                    :placeholder="placeholder" 
                    v-model="content" 
                    :options="editorOptions"
                    @ready="editorReady"
                    :readOnly="$attrs.readOnly"
                    >
                    </codemirror>

                    <small v-for="(error, index) in errors" :key="index">  {{ error }}  </small>
                </b-form-group>
                <slot></slot>
            </b-sidebar>
        </template>

        <template v-else>
            <b-modal :title="$attrs.label" size="xl" v-model="editor.show" hide-footer>
                <ul class="editor-controls" v-if="controls">
                    <li v-if="canDisplayControl('libs')"><Libs :libs="libs"/></li>
                    <li><Snippets @snippetUsed="implementSnippet" :code="snippetSelected" /></li>
                    <li><Controls :keys="extraKeys" /></li>
                </ul>
                <b-form-group 
                    :description="editor_description"
                >
                <div class="libs-editor-wrapper" :style="{height: `calc(${this.getLibsEditorLineCount()} * 21.4px)`, 'max-height': `calc(14*21.4px)`, 'overflow': 'hidden'}">
                <codemirror 
                    ref="editorLibs" 
                    :value="imports"
                    :options="libsEditorOptions"
                    :readOnly="true"
                    @ready="editorLibsReady"
                    :style="{visibility: (libs.length < 1 && vars.length < 1) ? 'hidden' : 'visible'}"
                    >
                    </codemirror>
                </div>
                <codemirror 
                    v-if="loadEditor"
                    ref="editor"
                    @input="onChange"
                    :placeholder="placeholder" 
                    v-model="content" 
                    :options="editorOptions"
                    @ready="editorReady"
                    :readOnly="$attrs.readOnly"
                ></codemirror>

                    <small v-for="(error, index) in errors" :key="index">  {{ error }}  </small>
                </b-form-group>
                <slot></slot>
            </b-modal>
        </template>
        
    </div>
    <div v-else>
        <ul class="editor-controls" v-if="controls">
            <li v-if="canDisplayControl('libs')"><Libs :libs="libs"/></li>
            <li><Snippets @snippetUsed="implementSnippet" :code="snippetSelected" /></li>
            <li><Controls :keys="extraKeys" /></li>
        </ul>
        <b-form-group 
            :description="editor_description"
        >
        <div class="libs-editor-wrapper" :style="{height: `calc(${this.getLibsEditorLineCount()} * 21.4px)`, 'max-height': `calc(14*21.4px)`, 'overflow': 'hidden'}">
            <codemirror 
            ref="editorLibs" 
            :value="imports"
            :options="libsEditorOptions"
            :readOnly="true"
            @ready="editorLibsReady"
            >
            </codemirror>
        </div>
            <codemirror 
            v-if="loadEditor"
            ref="editor"
            @input="onChange"
            :placeholder="placeholder" 
            v-model="content" 
            :options="editorOptions"
            @ready="editorReady"
            :readOnly="$attrs.readOnly"
            >
            </codemirror>

            <small v-for="(error, index) in errors" :key="index">  {{ error }}  </small>
        </b-form-group>
        <slot></slot>
    </div>
</template>

<style scoped>
.editor-controls {
    margin: 5px 0px 10px 0px;
    padding: 0;
    list-style: none;
}

.editor-controls > li {
    display: inline-block;
    margin: 0px 5px;
}

.line-error {
    background-color: red
}

.libs-editor-wrapper {
    height: 100px;
}

</style>

<style>
.CodeMirror-hints {
    z-index: 9999;
}

.CodeMirror-hint > span {
    display: none
}

.CodeMirror-hint-active > span {
    display: block;
    color: #ccc;
    padding: 5px;
}

.CodeMirror-hint-active > span a {
    color: #000;
}
</style>

<script>
// require component
import * as vueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/display/autorefresh.js'
import 'codemirror/addon/display/placeholder.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/javascript-hint.js'
import 'codemirror/addon/hint/anyword-hint.js'
import 'codemirror/addon/lint/json-lint.js'
import 'codemirror/addon/lint/javascript-lint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/lint/lint.js'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/addon/selection/mark-selection.js'
import 'codemirror/addon/selection/active-line.js'
import 'codemirror/theme/material-palenight.css'

import Libs from './Libs'
import Vars from './Vars'
import Snippets from './Snippets'
import Controls from './Controls'

import {parse, stringify} from 'comment-json'

export default {
    name: "Code",
    components: {
        codemirror: vueCodemirror.codemirror,
        Libs,
        Vars,
        Snippets,
        Controls
    },
    props: {
        value: {
            type: String
        },
        placeholder: {
            type: String
        },
        controls: {
            type: Array | Boolean,
            default: function() {
                return false;
            }
        },
        editor_description: {
            type: String
        },
        libs: {
            type: Array,
            default: function() {
                return []
            }
        },
        vars: {
            type: Array,
            default: function() {
                return []
            }
        },
        snippets: {
            type: Array,
            default: function() {
                return []
            }
        },
        lang: {
            type: String,
            default: 'text/javascript'
        },
        errors: {
            type: Array,
            default: function() {
                return []
            }
        },
        btnLabel: {
            type: String,
            default: 'Open editor'
        },
        withButton: {
            type: Boolean,
            default: true
        },
        sidebar: {
            type: Boolean,
            default: false
        }
    },
    data : function() {
        return {
            loadEditor: false,
            editor: {
                show: false,
            },
            snippetSelected: ''
        }
    },
    computed: {
        content: {
            get() {
                return this.value;
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        extraKeys() {
            let controls = {};

            controls["Ctrl-P"] = "Create snippet from selection";
            controls["Ctrl-Space || Tab"] = "Show hints";

            return controls;
        },


        imports() {
            let v = '';

            this.libs.forEach(l => {
                v += 'import ' + l.varName + ' from "'+ l.name +'";\n'
            })

            this.vars.forEach(r => {
                try {
                    let usage = stringify(parse(r.usage), null, 4)
                    v += '\nlet ' + r.name + ' = ' + usage + '\n'
                } catch {
                    v += '\nlet ' + r.name + ' = ' + r.usage + '\n'
                }
            })

            return v;
        },

        editorOptions() {
            let options = _.cloneDeep(this.libsEditorOptions)

            options.extraKeys = {
                "Ctrl-P": this.saveSnippet,
                'Ctrl-Space': this.showHint
            }

            options.readOnly = this.$attrs.readOnly || false
            options.firstLineNumber = this.getLibsEditorLineCount() + 1;

            return options
        },

        libsEditorOptions() {
            return {
                tabSize: 4,
                line: true,
                autoRefresh: true,
                lineNumbers: true,
                foldGutter: true,
                firstLineNumber: 1,
                styleSelectedText: true,
                mode: this.lang,
                matchBrackets: true,
                showCursorWhenSelecting: true,
                readOnly: true,
                theme: this.platformTheme()
            }
        }
    },
    methods: {
        canDisplayControl(ctrl) {
            if (this.controls.length > 0) {
                if (this.controls[0] == "*") {
                    return true
                }

                return this.controls.indexOf(ctrl) !== -1
            }
           
            return false;
            
        },

        implementSnippet(snippet) {
            let snippetCode = "// " + snippet.name + "\n";
            snippetCode += snippet.code + "\n";
            snippetCode += "// " + snippet.name;

            let content = this.content;

            content = snippetCode + "\n" + content;

            this.content = content;
        },

        saveSnippet(cm) {
            this.snippetSelected = cm.getSelection();
        },

        controlActionsEvent(e, data) {
            this.$emit("controlAction", e, data);
        },

        onChange(code) {
            this.$emit("onInput", code);
        },

        showHint(cm) {
            cm.showHint({
                completeSingle: false,
                alignWithWord: true,
                hint: vueCodemirror.CodeMirror.hint.protokol
            });
        },

        editorReady(cm) {
            this.loadEditor = true
        },

        beforeChange(e, d) {
            if (d.from.line <= 1) {
                d.cancel()
            }
        },

        getLibsEditorLineCount() {
            let editor = this.$refs.editorLibs;

            if (this.vars.length < 1 && this.libs.length < 1) {
                return 0
            }

            if (editor !== undefined) {
                return editor.codemirror.lineCount()
            }
        

            return null
        },

        editorLibsReady(cm) {
            this.loadEditor = true
            cm.doc.markText({ch:0, line: 0}, {ch:0, line: cm.lineCount() + 1}, {readOnly: true, css: 'color: #ccc'})
        },

        formatSnippets(snippets) {
            return snippets.map(s => {
                return {
                    text: s.text,
                    render: function(element, self, data) {
                        const wrapper = document.createElement('div');
                        wrapper.innerHTML = s.displayText;
                        element.appendChild(wrapper);

                        if (s.info !== undefined) {
                            const info = document.createElement('span');
                            let iText = s.info

                            if (s.docs !== undefined) {
                                iText = `${s.info} - (<a href="${s.docs}" target="_blank">See more</a>)`
                            }

                            info.innerHTML = iText;
                            element.appendChild(info)
                        }
                    }
                }
            })
        },

        platformTheme() {
            if (this.$store) {
                return this.$store.getters.getCurrentTheme == 'light' ? 'default' : 'material-palenight'
            }

            return 'material-palenight'
        }
    },

    mounted() {
        let CodeMirror = vueCodemirror.CodeMirror
        let snippets = this.formatSnippets(this.snippets)

        CodeMirror.registerHelper("hint", "protokol", function (editor, options) {
            let cursor = editor.getCursor();
            let line = editor.getLine(cursor.line);
            let start = cursor.ch, end = cursor.ch;
            // corrects ignoring trailing whitespaces removal
            while (start && /\w/.test(line.charAt(start - 1)))
                        --start;
            while (end < line.length && /\w/.test(line.charAt(end)))
                        ++end;
            const token = editor.getTokenAt(cursor);
            const currentWord = token.string;

            // reduce hint options if user has already entered something
            const list = snippets.filter(function (item) {
                return item.text.indexOf(currentWord) >= 0;
            });

            if (list.length < 1) {
                let results = CodeMirror.hint.javascript(editor, options)
                if (results.list < 1) {
                    return CodeMirror.hint.anyword(editor,options)
                }

                return results;
            }

            return {
                list: list.length ? list : snippets,
                from: CodeMirror.Pos(cursor.line, start),
                to: CodeMirror.Pos(cursor.line, end)
            };
        });

    }
}
</script>